import { IComponent } from "../Models/IComponent";

export class ComponentService {
  static readonly KEY = "ComponentService";

  private controllers: Map<string, any> = new Map();

  private viewComponentId: string | null = null;

  setViewComponentId(componentId: string) {
    this.viewComponentId = componentId;
  }

  getViewComponentId(): string | null {
    return this.viewComponentId;
  }

  register(component: IComponent, controller: any): void {
    this.controllers.set(component.Id, controller);
  }

  getController<T>(componentId?: string): T | undefined {
    if (!componentId) {
      componentId = this.viewComponentId!;
    }
    return this.controllers.get(componentId) as T | undefined;
  }

  getControllers<T>(): T[] {
    return [...this.controllers.values()] as T[];
  }
}
